<template>
  <DeepNodeIcon
    :color="
      type === 'folder' ? getTplColorByName('primary-lighten-1') : undefined
    "
    :type
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import { DeepNodeIcon, useTplColors } from '@deepcloud/deep-ui-lib'
import type { ExtractProps } from '@deepcloud/deep-ui-utils/vue'

defineProps({
  type: {
    type: String as PropType<ExtractProps<typeof DeepNodeIcon>['type']>,
    default: undefined,
  },
})

const { getTplColorByName } = useTplColors()
</script>
